import React__default, { useRef } from "react";
import { P as PropTypes, t as tagPropType, p as pick, o as omit, m as mapToCssModules, T as TransitionTimeouts, b as TransitionPropTypeKeys } from "./utils-65a8d69b.js";
import { c as classNames } from "./index-e71f83b5.js";
import { T as Transition } from "./Transition-a28a969d.js";
var _excluded = ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
}
var propTypes = _objectSpread(_objectSpread({}, Transition.propTypes), {}, {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tag: tagPropType,
  baseClass: PropTypes.string,
  baseClassActive: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
}), defaultProps = _objectSpread(_objectSpread({}, Transition.defaultProps), {}, {
  timeout: TransitionTimeouts.Fade,
  appear: !0,
  enter: !0,
  exit: !0,
  in: !0
});
function Fade(props) {
  var ref = useRef(null), _props$tag = props.tag, Tag = _props$tag === void 0 ? "div" : _props$tag, _props$baseClass = props.baseClass, baseClass = _props$baseClass === void 0 ? "fade" : _props$baseClass, _props$baseClassActiv = props.baseClassActive, baseClassActive = _props$baseClassActiv === void 0 ? "show" : _props$baseClassActiv, className = props.className, cssModule = props.cssModule, children = props.children, _props$innerRef = props.innerRef, innerRef = _props$innerRef === void 0 ? ref : _props$innerRef, otherProps = _objectWithoutProperties(props, _excluded), transitionProps = pick(_objectSpread({
    defaultProps
  }, otherProps), TransitionPropTypeKeys), childProps = omit(otherProps, TransitionPropTypeKeys);
  return /* @__PURE__ */ React__default.createElement(Transition, _extends({
    nodeRef: innerRef
  }, transitionProps), function(status) {
    var isActive = status === "entered", classes = mapToCssModules(classNames(className, baseClass, isActive && baseClassActive), cssModule);
    return /* @__PURE__ */ React__default.createElement(Tag, _extends({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}
Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
export {
  Fade as F
};
//# sourceMappingURL=Fade-5a502c0e.js.map
